const cacheKeys = {
  products: true,
  "course~<any>": true,
  "course_detail~<any>": true,
  "bundle~<any>": true,
  "bundle_detail~<any>": true,
  "all_courses": true,
  "slug~<any>" : true,
  "all_routes": true,
  "all_enquiry_fields": true,
  "secondary_data": true,
  "news_feed_lunch_url": true,
  "news_feeds":true
};

export default cacheKeys;
